import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/forgot", { email });
      setDone(true);
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="container-x" style={{ padding: "64px 0", display: "flex", justifyContent: "center" }}>
      <div className="card" style={{ width: "100%", maxWidth: 440, padding: 40 }}>
        <span className="overline">Reset password</span>
        <h1 className="font-serif" style={{ fontSize: 32, margin: "8px 0 16px", fontWeight: 500, letterSpacing: "-0.01em" }}>
          Forgot your password?
        </h1>

        {done ? (
          <div data-testid="forgot-success" style={{ textAlign: "center", padding: "8px 0" }}>
            <div style={{ width: 52, height: 52, borderRadius: "50%", background: "#E7F0EA", color: "var(--success)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
              <CheckCircle2 size={26} />
            </div>
            <p style={{ marginTop: 16, color: "var(--text)" }}>
              If that email is registered, we just sent a reset link. Check your inbox (and spam folder). The link is valid for 1 hour.
            </p>
            <Link to="/login" style={{ color: "var(--primary)", fontWeight: 500, marginTop: 20, display: "inline-block" }} data-testid="back-to-login">← Back to login</Link>
          </div>
        ) : (
          <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <p style={{ color: "var(--text-muted)", fontSize: 14, margin: 0 }}>
              Enter your email and we'll send you a link to set a new password.
            </p>
            <div>
              <label style={{ display: "block", fontSize: 14, fontWeight: 500, marginBottom: 6 }}>Email</label>
              <input data-testid="forgot-email-input" className="input-field" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" />
            </div>
            {err && <div data-testid="forgot-error" style={{ color: "var(--error)", fontSize: 14 }}>{err}</div>}
            <button data-testid="forgot-submit-btn" className="btn-primary" type="submit" disabled={busy} style={{ justifyContent: "center" }}>
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <div style={{ color: "var(--text-muted)", fontSize: 14, textAlign: "center" }}>
              Remembered it? <Link to="/login" style={{ color: "var(--primary)", fontWeight: 500 }} data-testid="forgot-back-to-login">Back to login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
